import { memo } from 'react';

import clsx from 'clsx';

import { Sprite } from '~/features/sprites/components/Sprite/Sprite';
import { IP90BasketUspItem } from '~/lib/data-contract';
import { Icon } from '~/shared/components/Icon/Icon';
import { Text } from '~/shared/components/Text/Text';

import styles from './productDetailsUsps.module.css';

export type ProductDetailsUspsProps = {
	usps: IP90BasketUspItem[];
	className?: string;
};

export const ProductDetailsUsps = memo(({ usps, className }: ProductDetailsUspsProps) => {
	if (!usps || !usps.length) {
		return null;
	}

	return (
		<ul className={clsx(styles.root, className)}>
			{usps.map((usp) => (
				<li
					key={usp.id}
					className={styles.item}
				>
					<Icon size="sm">
						<Sprite name={usp.icon} />
					</Icon>
					<Text variant="bodyXs">{usp.text}</Text>
				</li>
			))}
		</ul>
	);
});

ProductDetailsUsps.displayName = 'ProductDetailsUsps';
